import styled from 'styled-components'
import iconPunchcard from './images/icon-punchcard.svg'
import iconTape from './images/icon-tape.svg'
import iconHd from './images/icon-hd.svg'
import iconFloppy from './images/icon-floppy.svg'
import iconDisk from './images/icon-disk.svg'
import iconCd from './images/icon-cd.svg'
import iconZip from './images/icon-zip.svg'
import iconDvd from './images/icon-dvd.svg'
import iconStick from './images/icon-stick.svg'
import iconBluray from './images/icon-bluray.svg'
import iconSsd from './images/icon-ssd.svg'
import iconCloud from './images/icon-cloud.svg'

const Card = ({
  children,
  icon,
  name,
  year,
  capacity,
  color,
}: {
  children: any
  icon: any
  name: String
  year: String
  capacity: String
  color?: any
}) => {
  return (
    <Medium>
      <div className='icon'>
        <img src={icon} alt='icon' />
      </div>
      <Info>
        <Head className={color}>
          <h5>{name}</h5>
          <div className='year'>{year}</div>
        </Head>
        <Details>
          <div className='capacity'>{capacity}</div>
          <Compared>{children}</Compared>
        </Details>
      </Info>
    </Medium>
  )
}

const StorageEvolution = ({
  tenant,
  colorMode,
  isMobile,
}: {
  tenant?: Object
  colorMode?: String
  isMobile?: Boolean
}) => {
  return (
    <Storagemedia className={isMobile ? 'mobile' : 'desktop'}>
      <h3>Die Entwicklung von Datenträgern</h3>
      <h4>Speicherkapazität zu ausgewählten Zeitpunkten</h4>
      <Grid>
        <Column>
          <Card
            name='Lochkarte'
            icon={iconPunchcard}
            year='1890'
            capacity='~0,08 KB'
          >
            <div></div>
          </Card>
        </Column>

        <Column>
          <Card
            name='Magnetband'
            icon={iconTape}
            year='1951'
            capacity='~800 KB'
          >
            <div>&nbsp;</div>
            <div>
              10'000 ×{' '}
              <img src={iconPunchcard} className='small' alt='lochkarte' />
            </div>
          </Card>
        </Column>

        <Column>
          <Card name='Festplatte' icon={iconHd} year='1956' capacity='~5 MB'>
            <div>
              64'000 ×{' '}
              <img src={iconPunchcard} className='small' alt='lochkarte' />
            </div>
            <div>
              201 × <img src={iconTape} className='small' alt='magnetband' />
            </div>
          </Card>
        </Column>

        <Column>
          <Card
            name='5,25-Zoll Floppy-Disk'
            icon={iconFloppy}
            year='1976'
            capacity='110 KB'
          >
            <div>&nbsp;</div>
            <div>
              1375 ×{' '}
              <img src={iconPunchcard} className='small' alt='lochkarte' />
            </div>
          </Card>
        </Column>

        <Column>
          <Card
            name='3,5-Zoll Diskette'
            icon={iconDisk}
            year='1982'
            capacity='1,44 MB'
          >
            <div>
              18'432 ×{' '}
              <img src={iconPunchcard} className='small' alt='lochkarte' />
            </div>
            <div>
              2 × <img src={iconTape} className='small' alt='magnetband' />
            </div>
          </Card>
        </Column>

        <Column>
          <Card
            name='CD-ROM'
            icon={iconCd}
            year='1989'
            capacity='650 MB'
            color='orange'
          >
            <div>
              8,3 Mio. ×{' '}
              <img src={iconPunchcard} className='small' alt='lochkarte' />
            </div>
            <div>
              832 × <img src={iconTape} className='small' alt='magnetband' />
            </div>
            <div>
              6051 × <img src={iconFloppy} className='small' alt='floppydisk' />
            </div>
            <div>
              451 × <img src={iconDisk} className='small' alt='diskette' />
            </div>
          </Card>
        </Column>

        <Column>
          <Card
            name='Zip'
            icon={iconZip}
            year='1994'
            capacity='100 MB'
            color='orange'
          >
            <div>
              1,3 Mio. ×{' '}
              <img src={iconPunchcard} className='small' alt='lochkarte' />
            </div>
            <div>
              128 × <img src={iconTape} className='small' alt='magnetband' />
            </div>
            <div>
              931 × <img src={iconFloppy} className='small' alt='floppydisk' />
            </div>
            <div>
              69 × <img src={iconDisk} className='small' alt='diskette' />
            </div>
          </Card>
        </Column>

        <Column>
          <Card
            name='DVD'
            icon={iconDvd}
            year='1996'
            capacity='4,7 GB'
            color='orange'
          >
            <div>
              44'803 ×{' '}
              <img src={iconFloppy} className='small' alt='floppydisk' />
            </div>
            <div>
              3342 × <img src={iconDisk} className='small' alt='diskette' />
            </div>
            <div>&nbsp;</div>
            <div>
              7 × <img src={iconCd} className='small' alt='cd-rom' />
            </div>
          </Card>
        </Column>

        <Column>
          <Card
            name='USB-Stick'
            icon={iconStick}
            year='1999'
            capacity='~8 MB'
            color='orange'
          >
            <div>
              102'400 ×{' '}
              <img src={iconPunchcard} className='small' alt='lochkarte' />
            </div>
            <div>
              10 × <img src={iconTape} className='small' alt='magnetband' />
            </div>
            <div>
              64 × <img src={iconFloppy} className='small' alt='floppydisk' />
            </div>
            <div>
              6 × <img src={iconDisk} className='small' alt='diskette' />
            </div>
          </Card>
        </Column>

        <Column>
          <Card
            name='Blu-ray Disc'
            icon={iconBluray}
            year='2007'
            capacity='25 GB'
            color='green'
          >
            <div>
              238'313 ×{' '}
              <img src={iconFloppy} className='small' alt='floppydisk' />
            </div>
            <div>
              17'778 × <img src={iconDisk} className='small' alt='diskette' />
            </div>
            <div>
              39 × <img src={iconCd} className='small' alt='cd-rom' />
            </div>
            <div>
              5 × <img src={iconDvd} className='small' alt='dvd' />
            </div>
          </Card>
        </Column>

        <Column>
          <Card
            name='SSD'
            icon={iconSsd}
            year='2009'
            capacity='1 TB'
            color='green'
          >
            <div>
              9,8 Mio. ×{' '}
              <img src={iconFloppy} className='small' alt='floppydisk' />
            </div>
            <div>
              728'178 × <img src={iconDisk} className='small' alt='diskette' />
            </div>
            <div>
              1613 × <img src={iconCd} className='small' alt='cd-rom' />
            </div>
            <div>
              218 × <img src={iconDvd} className='small' alt='dvd' />
            </div>
          </Card>
        </Column>

        <Column>
          <Card
            name='Cloud'
            icon={iconCloud}
            year='2012'
            capacity='~1 EB'
            color='green'
          >
            <div>
              10,2 Bio. ×{' '}
              <img src={iconFloppy} className='small' alt='floppydisk' />
            </div>
            <div>
              763,5 Mrd. ×{' '}
              <img src={iconDisk} className='small' alt='diskette' />
            </div>
            <div>
              1,7 Mrd. × <img src={iconCd} className='small' alt='cd-rom' />
            </div>
            <div>
              228,5 Mio. × <img src={iconDvd} className='small' alt='dvd' />
            </div>
          </Card>
        </Column>
      </Grid>
    </Storagemedia>
  )
}
const Storagemedia = styled.div`
  font-family: var(--font-sans-serif);
  h3 {
    font-size: 1.8rem;
    font-weight: 700;
    margin-bottom: 1rem;
  }
  h4 {
    margin-bottom: 3rem;
  }
`

const Grid = styled.div`
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr 1fr;
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 1px;
  }
`
const Column = styled.div`
  margin: 0;
  padding: 0.5rem 1rem;
  @media (max-width: 768px) {
    margin: 0;
    padding: 0.4rem 0.4rem 0.4rem 0;
  }
`

const Medium = styled.div`
  display: grid;
  grid-template-columns: 0.85fr 4fr;
  margin-bottom: 1.2rem;
  .icon {
    _border: 1px solid yellow;
    img {
      width: 100%;
    }
    padding-right: 10%;
  }
`
const Info = styled.div``

const Head = styled.div`
  display: grid;
  grid-template-columns: 4fr 1fr;
  gap: 0.5rem;
  height: 2.8rem;
  border-bottom: 1px solid white;
  font-size: 1.6rem;
  line-height: 2rem;
  h5 {
    font-size: 1.6rem;
  }
  .year {
    text-align: right;
    font-weight: 700;
  }
  &.orange {
    _color: var(--orange-main);
    _border-color: var(--orange-main);
  }
  &.green {
    _color: var(--petrol-main);
    _border-color: var(--petrol-main);
  }
`

const Details = styled.div`
  display: grid;
  grid-template-columns: 1fr 3fr;
  padding-top: 0.4rem;
  font-size: 1.6rem;
  line-height: 2rem;
  .capacity {
    font-size: 1.5rem;
  }
`

const Compared = styled.div`
  font-size: 1.3rem;
  text-align: right;
  display: grid;
  grid-template-columns: 1fr 1fr;
  .small {
    height: 2.4rem;
    top: -0.2rem;
    left: -0.3rem;
    position: relative;
  }
`

export default StorageEvolution
